import React from "react";
import { tone, toMin, ymd } from "./typeColors";

const HOURS = Array.from({ length: 13 }, (_, i) => i + 7);
const PX_PER_MIN = 0.85;

const startOfWeek = (d) => {
  const x = new Date(d); x.setDate(x.getDate() - x.getDay()); x.setHours(0, 0, 0, 0); return x;
};

export default function WeekView({ date, appts, onOpen, onCreate }) {
  const start = startOfWeek(date);
  const days = Array.from({ length: 7 }, (_, i) => {
    const x = new Date(start); x.setDate(x.getDate() + i); return x;
  });
  const todayKey = ymd(new Date());

  return (
    <div data-testid="cal-week-view" className="overflow-x-auto">
      <div className="min-w-[900px]">
        <div className="grid" style={{ gridTemplateColumns: "56px repeat(7, minmax(0, 1fr))" }}>
          <div />
          {days.map((d) => {
            const isToday = ymd(d) === todayKey;
            return (
              <div key={d.toISOString()} className={`text-center py-2 ${isToday ? "text-indigo-600 dark:text-indigo-300" : "text-slate-600 dark:text-slate-300"}`}>
                <div className="text-[10px] font-semibold uppercase tracking-wider">{d.toLocaleDateString(undefined, { weekday: "short" })}</div>
                <div className={`text-lg font-bold font-display ${isToday ? "" : ""}`}>
                  <span className={isToday ? "inline-flex h-8 w-8 items-center justify-center rounded-full brand-gradient text-white" : ""}>{d.getDate()}</span>
                </div>
              </div>
            );
          })}
        </div>

        <div className="grid" style={{ gridTemplateColumns: "56px repeat(7, minmax(0, 1fr))" }}>
          <div className="pr-2">
            {HOURS.map((h) => (
              <div key={h} className="text-[10px] font-mono text-slate-400 text-right pt-1" style={{ height: `${60 * PX_PER_MIN}px` }}>
                {String(h).padStart(2, "0")}
              </div>
            ))}
          </div>
          {days.map((d) => {
            const key = ymd(d);
            const list = appts.filter((a) => a.date === key);
            return (
              <div key={key} className="relative border-l border-slate-200 dark:border-white/10">
                {HOURS.map((h) => (
                  <button
                    key={h}
                    data-testid={`cal-week-slot-${key}-${h}`}
                    onClick={() => onCreate({ date: key, time: `${String(h).padStart(2, "0")}:00` })}
                    className="block w-full border-b border-slate-100 dark:border-white/5 hover:bg-indigo-50/40 dark:hover:bg-indigo-500/10 transition-colors"
                    style={{ height: `${60 * PX_PER_MIN}px` }}
                  />
                ))}
                {list.map((a) => {
                  const s = toMin(a.time) - HOURS[0] * 60;
                  const e = a.end_time ? toMin(a.end_time) - HOURS[0] * 60 : s + 60;
                  const top = Math.max(0, s * PX_PER_MIN);
                  const height = Math.max(22, (e - s) * PX_PER_MIN);
                  const t = tone(a.type);
                  return (
                    <button
                      key={a.id}
                      data-testid={`cal-week-appt-${a.id}`}
                      onClick={() => onOpen(a)}
                      className={`absolute left-1 right-1 rounded-lg text-left p-1.5 border shadow-sm hover:shadow-md transition-all ${t.soft} overflow-hidden`}
                      style={{ top: `${top}px`, height: `${height}px` }}
                    >
                      <div className="flex items-center gap-1 text-[9px] font-mono opacity-80">
                        <span className={`inline-block h-1 w-1 rounded-full ${t.bg}`} />
                        {a.time}
                      </div>
                      <div className="text-[11px] font-semibold truncate leading-tight">{a.title}</div>
                    </button>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
